import { ORDER_DISPLAY_STATUS_TONE } from '@/config/statusTones';
import { BadgeVariants } from '@carboledger/ui';
import { UNIT_TYPES } from '@/config/unitTypes.constants';

// The order row's discrepancy popup — GENERAL DETAILS + the quantities, per Figma 4196:123426.

/** The one sentence the popup leads with; the server sends a 0/1 flag, not a message. */
export const buildLinkableOrderDiscrepancyMessage = (t, order) => {
  if (!order) return undefined;
  return t('LINK_ORDERS_DISCREPANCY_MESSAGE', {
    days: order.daysToDispatch ?? 0,
    quantity: order.byUnit?.[Object.keys(order.byUnit ?? {})[0]]?.remainingToShipQuantity ?? '-',
  });
};

export const buildLinkableOrderDiscrepancySections = (t, order, unitType) => {
  if (!order) return [];
  const quantities = order.byUnit?.[unitType] ?? order.byUnit?.[Object.keys(order.byUnit ?? {})[0]];
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: order.materialName },
        {
          label: t('FIELD_STATUS'),
          value: order.status,
          type: 'status',
          tone: ORDER_DISPLAY_STATUS_TONE[order.status] ?? BadgeVariants.default,
        },
        { label: t('FIELD_SOLD_TO'), value: order.soldTo },
        { label: t('FIELD_SHIPPING_TO'), value: order.shippingTo },
        { label: t('FIELD_TERMINAL'), value: order.terminal },
        { label: t('FIELD_DISPATCH_BY'), value: order.dispatchBy },
      ],
    },
    {
      title:
        unitType === UNIT_TYPES.working
          ? t('SECTION_QUANTITY_IN_WORKING_UNIT')
          : t('SECTION_QUANTITY_IN_DECLARATION_UNIT'),
      fields: [
        { label: t('FIELD_CONTRACTED_QUANTITY'), value: quantities?.contractedQuantity },
        { label: t('FIELD_SHIPPED_QUANTITY'), value: quantities?.shippedQuantity },
        { label: t('FIELD_ALLOCATED_QUANTITY'), value: quantities?.allocatedQuantity },
        {
          label: t('FIELD_REMAINING_TO_ALLOCATE_QUANTITY'),
          value: quantities?.remainingToAllocateQuantity,
        },
      ],
    },
  ];
};
